import { defineComponent } from 'vue';
export default defineComponent({
  name: 'HeaderNav',
  props: {
    content: {
      type: String,
      "default": function _default() {
        return '';
      }
    }
  }
});